import { Grid, Box } from '@mui/material'
import { Typography } from '@nwh-consumer-digital/nw-component-lib'

const adultPageFourSuccess = (props) => {
  return (
    <Box className='pageContainer'>
      <Grid container direction='column' justifyContent='space-between' alignItems='left'>
        <Grid item xs={12}>
          <img src='/images/Check.png' className='imgAlign'></img>
          <Typography variant='h1' style={{ marginTop: 80, marginBottom: 16 }} className='imgAlign noPad'>
            成功了！
          </Typography>
        </Grid>
        <Grid item xs={12} s={12} md={12}>
          <Typography type='body' size='large' weight='light'>
            {' '}
            请在接下来的5天内收到邀请函，并附有如何创建授权个人账户的说明。
          </Typography>
        </Grid>
      </Grid>
    </Box>
  )
}
export default adultPageFourSuccess
